import React from 'react'

import { withRouter } from 'react-router-dom'

const CartDetailNavbar = ({ history }) => (
  <nav className="navbar bg-white align-center shadow-sm d-flex justify-content-between">
    <div onClick={() => history.goBack()}>
      <i
        className="fas fa-arrow-left"
        style={{ color: '#aaa', fontSize: '1.2rem' }}
      />
    </div>

    <div className="navbar-text mb-0">
      <div style={{ fontSize: '1.1rem' }}>Cart Detail</div>
    </div>

    <div></div>
  </nav>
)

export default withRouter(CartDetailNavbar)
